const EMPTY_ARRAY = [];
export function filterByProperties(list, properties, value) {
    try {
        return list.filter(item => {
            return properties.some(property => {
                return String(item[property]).toLowerCase().includes(value.toString().toLowerCase());
            });
        });
    }
    catch {
        return EMPTY_ARRAY;
    }
}
